import { render, staticRenderFns } from "./CoursesGradesList.vue?vue&type=template&id=04be1fb5&"
import script from "./CoursesGradesList.vue?vue&type=script&lang=js&"
export * from "./CoursesGradesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04be1fb5')) {
      api.createRecord('04be1fb5', component.options)
    } else {
      api.reload('04be1fb5', component.options)
    }
    module.hot.accept("./CoursesGradesList.vue?vue&type=template&id=04be1fb5&", function () {
      api.rerender('04be1fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CoursesAndGrades/CoursesGradesList.vue"
export default component.exports